import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Picker } from './Picker';
export const YearPicker = ({ label = 'Year', placeHolder = 'Please Select Year', ...props }) => {
    const yearItems = useMemo(() => {
        const MIN_YEAR = 1900;
        const currentYear = new Date().getFullYear() + 1;
        const yearDistance = currentYear - MIN_YEAR;
        const years = new Array(yearDistance)
            .fill(MIN_YEAR)
            .map((year, index) => year + index)
            .sort((a, b) => b - a);
        years.unshift(undefined);
        return years.map((year) => {
            return year === undefined
                ? {
                    label: placeHolder,
                    value: undefined,
                }
                : { label: year.toString(), value: year };
        });
    }, []);
    return _jsx(Picker, { label: label, items: yearItems, ...props });
};
